import React, { Fragment } from 'react';
import Typography from '@material-ui/core/Typography';
import strings from 'strings';

/**
 * @param {Object} props
 * @param {Array<LogType>} props.logs
 */
const ChangeLogsDifferentiated = ({ logs }) => {
  if (!logs) return null;

  return logs?.length === 0 ? (
    <Typography gutterBottom>
      {strings.inventoryProfiles.sections.tabs.changeLogs.drawer.empty}
    </Typography>
  ) : (
    recursiveLogs(logs)
  );
};

/**
 * @param {Array<LogType>} logs
 */
export const recursiveLogs = logs => {
  if (!logs) return null;

  return (
    <ul>
      {logs.map(log => (
        <Fragment key={log.label}>
          <li>
            <Typography gutterBottom>{log.label}</Typography>
            {log?.logs?.length > 0 && recursiveLogs(log.logs)}
          </li>
        </Fragment>
      ))}
    </ul>
  );
};

export default ChangeLogsDifferentiated;
